import React from 'react';
import Button from '@mui/material/Button';
import { useTheme } from '@mui/material/styles';

const StyledButton = ({ onClick, icon: Icon, fullWidth = false, type = "button", marginTop = '20px', children, ...props }) => {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      startIcon={Icon && <Icon />}
      onClick={onClick}
      fullWidth={fullWidth}
      type={type}
      sx={{
        height: 48, // Slightly taller for better touch target
        marginTop: marginTop,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontWeight: 600,
        borderRadius: 2,
        textTransform: 'none',
        boxShadow: 2,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
          boxShadow: 4,
        },
        '& .MuiButton-startIcon': {
          color: theme.palette.secondary.light,
        },
        ...props.sx // Allow overriding styles via props
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default StyledButton;
